<template>
  <div class="registry-connections-display">
    <p
      v-if="!registryConnections || registryConnections.length === 0"
      class="text-muted small mb-0"
    >
      No registry connections
    </p>
    <table v-else class="table table-sm table-borderless mb-0">
      <thead>
        <tr>
          <th class="small">Integration</th>
          <th class="small">Registry ID</th>
          <th class="small">EECS</th>
          <th class="small">Region</th>
          <th class="small">Type</th>
          <th class="small">Status</th>
          <th class="small">Transaction log</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="connection in registryConnections" :key="connection.id">
          <td class="small">
            {{ connection.integration_name }}
          </td>
          <td class="small">
            {{ connection.registry_company_id || "N/A" }}
          </td>
          <td class="small">{{ connection.registry_eecs || "N/A" }}</td>
          <td class="small">{{ connection.region }}</td>
          <td>
            <span
              class="badge badge-sm"
              :class="{
                'bg-dark-subtle': connection.connection_type === 'VIRTUAL',
                'bg-primary': connection.connection_type === 'STANDARD',
              }"
            >
              {{
                connection.connection_type === "VIRTUAL"
                  ? "Virtual"
                  : "Standard"
              }}
            </span>
          </td>
          <td>
            <span
              class="badge badge-sm"
              :class="{
                'bg-success': connection.is_active,
                'bg-secondary': !connection.is_active,
              }"
            >
              {{ connection.is_active ? "Active" : "Inactive" }}
            </span>
          </td>
          <td>
            <span
              class="badge badge-sm"
              :class="
                transactionLogApplies(connection)
                  ? 'bg-success'
                  : 'bg-secondary'
              "
              :title="transactionLogOffReason(connection) ?? undefined"
            >
              {{ transactionLogApplies(connection) ? "On" : "Off" }}
            </span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script setup lang="ts">
import {
  transactionLogApplies,
  transactionLogOffReason,
} from "@/registryUtils";
import type { RegistryConnection } from "@/types";

interface Props {
  registryConnections: RegistryConnection[];
}

defineProps<Props>();
</script>

<style scoped lang="scss">
.registry-connections-display {
  .table {
    font-size: 0.85rem;

    th {
      font-weight: 600;
      padding: 0.25rem 0.5rem;
      border-bottom: 1px solid var(--bs-border-color);
    }

    td {
      padding: 0.25rem 0.5rem;
    }
  }

  .badge-sm {
    font-size: 0.75rem;
    padding: 0.2rem 0.5rem;
  }
}
</style>
